import { NgModule } from '@angular/core';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER,
  TRANSLOCO_TRANSPILER,
  DefaultTranspiler,
  TranslocoConfig,
  translocoConfig,
  TranslocoMissingHandler,
  TranslocoModule,
  TRANSLOCO_INTERCEPTOR,
  DefaultInterceptor,
  TRANSLOCO_FALLBACK_STRATEGY,
  DefaultFallbackStrategy
} from '@jsverse/transloco';
import { logger } from '@utils/logger.service';

import { AVAILABLE_LANGUAGES, SUPPORTED_LANGUAGES } from '@app/models/languages';
import { environment } from '@environments/environment';
import { TranslateService } from './services/translate.service';
import { TranslocoHttpLoader } from './services/transloco-http-loader';

// Catches missing keys
//  DEV shows key of missing translation and logs error to console
//  PROD shows empty string
export class CustomHandler implements TranslocoMissingHandler {
  handle(key: string, config: TranslocoConfig) {
    if (!environment.production) {
      logger.warn(`Missing translation for key ${key}`);
      return key;
    }

    return '';
  }
}

export const customMissingHandler = {
  provide: TRANSLOCO_MISSING_HANDLER,
  useClass: CustomHandler
};

@NgModule({
  exports: [TranslocoModule],
  imports: [TranslocoModule],
  providers: [
    TranslateService,
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: AVAILABLE_LANGUAGES,
        flatten: {
          // false value enables transloco flattening the translation object
          //  { 'common': { 'email' } } to become { 'common.email' } and t('common.email') return translation string
          aot: false
        },
        prodMode: environment.production,
        reRenderOnLangChange: true,
        defaultLang: SUPPORTED_LANGUAGES.en_US,
        fallbackLang: SUPPORTED_LANGUAGES.en_US,
        missingHandler: { useFallbackTranslation: true }
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    { provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler },
    { provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor },
    { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: DefaultFallbackStrategy },
    customMissingHandler
  ]
})
export class TranslateModule {}
